import React, { useImperativeHandle, useState } from "react";
import NumberFormat from "react-number-format";
import useBSSController from "../../hooks/useBSSController";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material"; 
import BSSText from "./BSSText";
import __t from "../../lib/traduzioni";
import useBSSLogger from '../../hooks/useBSSLogger';

const {logger} = useBSSLogger();


//funziona finchè non si fa il submit dopo lagga (e la validazione non va)                        

const BSSNumber = ({
    name, 
    label = name,
    methods,
    dependsOn = null,
    ControllerProps = {},
    TextFieldProps = {},
    TextFieldInputProps = {},
    NumberFormatProps={}
}) => {

    const bssController = useBSSController({name, defaultValue: 0, dependsOn, methods});
    const {classes, control, dipendenze, disabilitaByDep, defaultValue} = bssController;

    return (
        <Controller
            name={name}
            defaultValue={defaultValue}
            control={control}
            render={({field, fieldState, formState}) => {

                return (
                    <NumberFormat
                        onFocus={e => e.target.select()}                                                
                        decimalScale={2}

                        control={control}
                        {...field}
                        fixedDecimalScale={true}             
                        fullWidth
                        size="small"
                        variant="outlined"
                        label={label}
                        helperText={fieldState?.error?.message ?? undefined}
                        error={fieldState?.invalid ?? false}
                        {...TextFieldProps}
                        customInput={TextField}   
                        
                        
                        onValueChange={(c) => {
                            logger.debug("valore cambiato bss number", c)
                            field.onChange(c.floatValue);
                            if(NumberFormatProps.afterChange){
                                NumberFormatProps.afterChange(c.floatValue)
                            }
                        }}
                        {...NumberFormatProps}
                    />
                )
            }}
            {...ControllerProps}
        />
        
    );
}


export default BSSNumber;